"use client"
import styles from "./Card.module.css"

const Card = ({
  title,
  children,
  footer,
  headerButtons = [],
  headerRight = null, 
  width,
  height,
  variant = "default",
  elevation = "medium",
  className = "",
  noPadding = false,
  bordered = false,
}) => {
  return (
    <div
      className={`${styles.card} ${styles[`card_${variant}`]} ${styles[`elevation_${elevation}`]} ${
        bordered ? styles.bordered : ""
      } ${className}`}
      style={{
        "--card-width": width || "100%",
        "--card-height": height || "auto",
      }}
    >
      {title && (
        <div className={styles.card_header}>
          <h3 className={styles.card_title}>{title}</h3>

          {/* 🔹 Render either custom right content or header buttons */}
          <div className={styles.card_header_right}>
            {headerRight ? (
              headerRight
            ) : (
              headerButtons?.length > 0 && (
                <div className={styles.header_buttons}>
                  {headerButtons.map((button, index) => (
                    <button
                      key={index}
                      className={`${styles.header_button} ${styles[`button_${button.variant || "default"}`]} ${
                        button.disabled ? styles.disabled : ""
                      }`}
                      onClick={button.onClick}
                      disabled={button.disabled}
                      title={button.tooltip}
                      aria-label={button.label}
                    >
                      {button.icon && <span className={styles.button_icon}>{button.icon}</span>}
                      {button.label && <span className={styles.button_label}>{button.label}</span>}
                    </button>
                  ))}
                </div>
              )
            )}
          </div>
        </div>
      )}

      <div className={`${styles.card_body} ${noPadding ? styles.no_padding : ""}`}>{children}</div>
      {footer && <div className={styles.card_footer}>{footer}</div>}
    </div>
  )
}

export default Card
